import { API_BASE_URL } from "../config";
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const Summary = () => {
  const { user, wallet } = useContext(AuthContext);
  const [holdings, setHoldings] = useState([]);
  const [activeTab, setActiveTab] = useState("dashboard");

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/client/allHoldings`)
      .then(res => {
        const holdingsData = Array.isArray(res.data) ? res.data : (res.data?.holdings || []);
        setHoldings(holdingsData);
      })
      .catch(err => console.error("Error fetching holdings summary", err));
  }, []);

  const safeHoldings = Array.isArray(holdings) ? holdings : [];
  const totalInvestment = safeHoldings.reduce((sum, h) => sum + ((h.avg || 0) * (h.qty || 0)), 0);
  const currentValue = safeHoldings.reduce((sum, h) => sum + ((h.price || 0) * (h.qty || 0)), 0);
  const totalPnL = currentValue - totalInvestment;
  const pnlPercent = totalInvestment > 0 ? (totalPnL / totalInvestment) * 100 : 0;

  const marginAvailable = wallet?.marginAvailable ?? 100000;
  const marginUsed = wallet?.marginUsed ?? 0;
  const openingBalance = wallet?.virtualBalance ?? 100000;

  const userName = user?.name ? user.name.split(" ")[0] : "Nikhil";

  return (
    <div style={{ padding: "20px 30px", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", color: "#444" }}>
      
      {/* Sub-Header Tabs: Dashboard | Screener */}
      <div style={{ display: "flex", gap: "24px", borderBottom: "1px solid #eee", marginBottom: "24px", paddingBottom: "0px" }}>
        <button
          onClick={() => setActiveTab("dashboard")}
          style={{
            background: "none",
            border: "none",
            padding: "8px 4px 12px 4px",
            fontSize: "14px",
            fontWeight: 600,
            cursor: "pointer",
            color: activeTab === "dashboard" ? "#ff5722" : "#666",
            borderBottom: activeTab === "dashboard" ? "2px solid #ff5722" : "2px solid transparent"
          }}
        >
          Dashboard
        </button>
        <button
          onClick={() => setActiveTab("screener")}
          style={{
            background: "none",
            border: "none",
            padding: "8px 4px 12px 4px",
            fontSize: "14px",
            fontWeight: 600,
            cursor: "pointer",
            color: activeTab === "screener" ? "#ff5722" : "#666",
            borderBottom: activeTab === "screener" ? "2px solid #ff5722" : "2px solid transparent"
          }}
        >
          Screener
        </button>
      </div>

      {activeTab === "screener" ? (
        <div style={{ padding: "40px 20px", textAlign: "center", color: "#888", backgroundColor: "#fafafa", borderRadius: "8px", border: "1px dashed #ddd" }}>
          <h3 style={{ margin: "0 0 8px 0", color: "#444" }}>🔍 Market Screener</h3>
          <p style={{ margin: 0, fontSize: "14px" }}>Filter top gainers, losers, and high volume instruments across NSE Equities & F&O.</p>
        </div>
      ) : (
        <>
          {/* Greeting */}
          <div style={{ marginBottom: "32px" }}>
            <h1 style={{ margin: 0, fontSize: "28px", fontWeight: 400, color: "#444" }}>
              Hi, {userName}
            </h1>
          </div>

          {/* Equity & Commodity Margin Cards Container */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px", marginBottom: "40px" }}>
            
            {/* Equity Margin Card */}
            <div style={{ paddingRight: "20px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px", color: "#444" }}>
                <span style={{ fontSize: "16px" }}>🕒</span>
                <span style={{ fontSize: "16px", fontWeight: 500 }}>Equity</span>
              </div>

              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                  <div style={{ fontSize: "42px", fontWeight: 300, color: "#444", lineHeight: 1 }}>
                    {marginAvailable < 1000 ? marginAvailable.toFixed(1) : marginAvailable.toLocaleString('en-IN')}
                  </div>
                  <div style={{ fontSize: "13px", color: "#9b9b9b", marginTop: "6px" }}>
                    Margin available
                  </div>
                </div>

                <div style={{ borderLeft: "1px solid #eee", paddingLeft: "30px" }}>
                  <div style={{ fontSize: "13px", color: "#666", marginBottom: "8px" }}>
                    Margins used <span style={{ color: "#444", fontWeight: 600, marginLeft: "12px" }}>₹{marginUsed.toLocaleString('en-IN')}</span>
                  </div>
                  <div style={{ fontSize: "13px", color: "#666", marginBottom: "12px" }}>
                    Opening balance <span style={{ color: "#444", fontWeight: 600, marginLeft: "12px" }}>₹{openingBalance.toLocaleString('en-IN')}</span>
                  </div>
                  <Link to="/statement" style={{ color: "#387ed1", fontSize: "13px", textDecoration: "none", fontWeight: 500 }}>
                    🔵 View statement
                  </Link>
                </div>
              </div>
            </div>

            {/* Commodity Margin Card */}
            <div style={{ paddingLeft: "20px", borderLeft: "1px solid #f0f0f0" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px", color: "#444" }}>
                <span style={{ fontSize: "16px" }}>⭕</span>
                <span style={{ fontSize: "16px", fontWeight: 500 }}>Commodity</span>
              </div>

              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                  <div style={{ fontSize: "42px", fontWeight: 300, color: "#444", lineHeight: 1 }}>
                    0
                  </div>
                  <div style={{ fontSize: "13px", color: "#9b9b9b", marginTop: "6px" }}>
                    Margin available
                  </div>
                </div>

                <div style={{ borderLeft: "1px solid #eee", paddingLeft: "30px" }}>
                  <div style={{ fontSize: "13px", color: "#666", marginBottom: "8px" }}>
                    Margins used <span style={{ color: "#444", fontWeight: 600, marginLeft: "12px" }}>0</span>
                  </div>
                  <div style={{ fontSize: "13px", color: "#666", marginBottom: "12px" }}>
                    Opening balance <span style={{ color: "#444", fontWeight: 600, marginLeft: "12px" }}>0</span>
                  </div>
                  <Link to="/statement" style={{ color: "#387ed1", fontSize: "13px", textDecoration: "none", fontWeight: 500 }}>
                    🔵 View statement
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "30px 0" }} />

          {/* Holdings / Portfolio Summary */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px", color: "#444" }}>
              <span style={{ fontSize: "16px" }}>💼</span>
              <span style={{ fontSize: "16px", fontWeight: 500 }}>Holdings ({holdings.length})</span>
            </div>

            {holdings.length === 0 ? (
              <div style={{ padding: "20px 0", color: "#888", fontSize: "14px" }}>
                No holdings active. Place delivery (CNC) buy orders to build your paper portfolio.
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: "40px" }}>
                <div>
                  <div style={{ fontSize: "36px", fontWeight: 300, color: totalPnL >= 0 ? "#089981" : "#f23645", lineHeight: 1 }}>
                    ₹{totalPnL.toFixed(2)}
                    <span style={{ fontSize: "14px", marginLeft: "8px", fontWeight: 500 }}>
                      ({pnlPercent >= 0 ? "+" : ""}{pnlPercent.toFixed(2)}%)
                    </span>
                  </div>
                  <div style={{ fontSize: "13px", color: "#9b9b9b", marginTop: "6px" }}>
                    P&L (Unrealized)
                  </div>
                </div>

                <div style={{ borderLeft: "1px solid #eee", paddingLeft: "30px" }}>
                  <div style={{ fontSize: "13px", color: "#666", marginBottom: "8px" }}>
                    Current Value <span style={{ color: "#444", fontWeight: 600, marginLeft: "12px" }}>₹{currentValue.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span>
                  </div>
                  <div style={{ fontSize: "13px", color: "#666" }}>
                    Investment <span style={{ color: "#444", fontWeight: 600, marginLeft: "12px" }}>₹{totalInvestment.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Summary;
